import { config } from "../config";
/**
 * Draws detections onto a canvas. Assumes the image has already been drawn as
 * the base layer and the canvas is sized to match result.imageWidth/Height.
 */
export function drawOverlay(canvas, result) {
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        throw new Error("drawOverlay: canvas 2D context unavailable");
    }
    ctx.lineWidth = Math.max(2, canvas.width / 400);
    ctx.textBaseline = "top";
    ctx.font = `${Math.max(12, canvas.width / 60)}px system-ui, sans-serif`;
    for (const det of result.detections) {
        const color = colorForClass(det.class);
        ctx.strokeStyle = color;
        ctx.fillStyle = color + "33"; // 20% opacity fill
        if (det.points && det.points.length > 2) {
            drawPolygon(ctx, det.points);
        }
        else {
            drawBox(ctx, det);
        }
        drawLabel(ctx, det, color);
    }
}
export function colorForClass(className) {
    const map = config.classColors;
    return map[className] ?? config.unknownClassColor;
}
function drawPolygon(ctx, points) {
    ctx.beginPath();
    const [first, ...rest] = points;
    if (!first)
        return;
    ctx.moveTo(first.x, first.y);
    for (const p of rest)
        ctx.lineTo(p.x, p.y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
}
function drawBox(ctx, det) {
    const x = det.x - det.width / 2;
    const y = det.y - det.height / 2;
    ctx.beginPath();
    ctx.rect(x, y, det.width, det.height);
    ctx.fill();
    ctx.stroke();
}
function drawLabel(ctx, det, color) {
    const label = `${det.class} ${Math.round(det.confidence * 100)}%`;
    const x = det.x - det.width / 2;
    const y = det.y - det.height / 2 - 4;
    const metrics = ctx.measureText(label);
    const pad = 4;
    const h = parseInt(ctx.font, 10) + pad * 2;
    const w = metrics.width + pad * 2;
    ctx.fillStyle = color;
    ctx.fillRect(x, y - h, w, h);
    ctx.fillStyle = "white";
    ctx.fillText(label, x + pad, y - h + pad);
}
